import Model from 'flarum/common/Model';

/** A saved reply: a common answer staff insert into a ticket reply. */
export default class SupportSavedReply extends Model {
  title = (() => Model.attribute('title'))();
  content = (() => Model.attribute('content'))();
  position = (() => Model.attribute('position'))();
}
flarum.reg.add('linkrobins-support', 'common/models/SupportSavedReply', SupportSavedReply);